import { connect } from 'react-redux';

import { Vehicle } from '@sm360/widget-commons-vehicle';

function mapStateToProps(state) {
    return {
        vehicle: state.vehicleV25,
    };
}

export default connect(mapStateToProps)(Vehicle.VehicleBannerWithCarrousel);
